module.exports = __webpack_public_path__ + "assets/standards.a5ad52d8.svg";